export const challenges = [
  {
    title: "Your GI nutrition references are scattered",
    body: [
      "You've collected information from textbooks, research articles, professional courses, and educational materials.",
      "But when you want to revisit a particular concept, finding the right reference can take longer than expected.",
    ],
    approach: "Organize related gastrointestinal nutrition topics within one structured educational reference collection.",
  },
  {
    title: "You want a clearer framework for nutritional assessment",
    body: [
      "Gastrointestinal nutrition assessment can involve dietary intake, symptom history, weight trends, nutritional status, medical history, and other relevant information.",
      "You want a structured way to study these elements and understand how they fit into a broader educational framework.",
    ],
    approach: "Use organized assessment frameworks, educational worksheets, and reference materials covering gastrointestinal nutrition considerations.",
  },
  {
    title: "You want to better understand digestion and nutrient absorption",
    body: [
      "Digestion, absorption, gastrointestinal function, and nutrient metabolism involve multiple interconnected processes.",
      "You want to study these concepts without constantly switching between disconnected educational resources.",
    ],
    approach: "Explore structured educational references, visual concept maps, and comparison materials covering digestive physiology and nutrient-related concepts.",
  },
  {
    title: "You need a more organized approach to gastrointestinal case review",
    body: [
      "Gastrointestinal nutrition cases can involve multiple nutritional and clinical considerations.",
      "You want a systematic way to organize the information you review, identify relevant questions, and structure your educational analysis.",
    ],
    approach: "Use hypothetical case studies, case-analysis worksheets, and structured educational review frameworks.",
  },
  {
    title: "You want to keep your documentation and study materials organized",
    body: [
      "Assessment records, dietary histories, educational case notes, and reference materials can become difficult to manage when they're scattered across different files.",
      "You want these resources to be easier to locate and organize.",
    ],
    approach: "Access educational documentation templates, assessment worksheets, and reference organization tools designed for professional adaptation.",
  },
  {
    title: "You want to organize your continuing professional education",
    body: [
      "Your understanding of gastrointestinal nutrition evolves as research and clinical recommendations develop.",
      "You want an educational reference collection that helps you revisit important concepts and organize your learning.",
    ],
    approach: "Maintain a structured educational library covering major areas of gastrointestinal nutrition, from foundational physiology to assessment, case analysis, and documentation.",
  },
];
